import React, {Fragment, Component} from 'react';
import styled from 'styled-components';
import Grid from 'styled-components-grid';
import CardGrid from '../common/card-grid/CardGrid';
import Card from '../common/card-grid/Card';
import NextPageButton from '../common/NextPageButton';
import CardGridUnit from '../common/card-grid/CardGridUnit';
import Calendar from '../common/calendar/Calendar';
import quickSettings from '../../constants/periods';
import gql from 'graphql-tag';
import {withApollo} from 'react-apollo';
import {Query} from 'react-apollo';
import {FILTER_CUSTOM} from '../../constants/filters';
import {format} from 'date-fns';
import {updateMutation} from '../settings/Select';
import Loading from './Loading';
import Error from './Error';

const QuickSetting = styled.button`
  padding: ${({theme}) => theme.spacingHorizontal()} ${({theme}) => theme.spacingVertical()};
  cursor: pointer;
  outline: none;
  border: 0;
  width: 100%;
  text-align: center;
  color: ${({theme, selected}) => (selected ? theme.white : theme.black)};
  background-color: ${({theme, selected}) => (selected ? theme.primaryColor : theme.white)};
  &:hover {
    background-color: ${({theme, selected}) => (selected ? theme.primaryColor : theme.lightGray)};
  }
`;

const ContentHeightCard = styled(Card)`
  height: auto;
`;

const periodSettingsQuery = gql`
  query periodSettings($input: SettingsQueryInput!) {
    settings(input: $input) {
      id
      period {
        type
        range {
          start
          end
        }
      }
    }
  }
`;

const DATE_REGEX = /^(\d*)-(\d\d)-(\d\d) (\d\d):(\d\d):(\d\d)$/;

const parseDate = dateString => {
  const year = dateString.match(DATE_REGEX)[1];
  const month = dateString.match(DATE_REGEX)[2];
  const day = dateString.match(DATE_REGEX)[3];
  return new Date(
    parseInt(year, 10),
    parseInt(month, 10) - 1, //it takes the month index, which starts with 0
    parseInt(day, 10)
  );
};

class PeriodSettingsContainer extends Component {
  state = {
    type: this.props.settings.period.type,
    range: {
      startDate:
        this.props.settings.period.range && this.props.settings.period.range.start
          ? parseDate(this.props.settings.period.range.start)
          : null,
      endDate:
        this.props.settings.period.range && this.props.settings.period.range.end
          ? parseDate(this.props.settings.period.range.end)
          : null
    }
  };

  select = k => {
    // Todo: remove for favorite settings saving implementation
    if (typeof this.props.favoriteId !== 'undefined') return;
    this.setState({type: k, range: null}, () => this.checkDataComplete());
  };

  range = r => {
    this.setState({range: r}, () => this.checkDataComplete());
  };

  checkDataComplete = t => {
    if (
      !(
        (this.state.type === FILTER_CUSTOM &&
          this.state.range &&
          this.state.range.startDate &&
          this.state.range.endDate) ||
        this.state.type !== FILTER_CUSTOM
      )
    )
      return;
    let range = null;
    if (this.state.type === FILTER_CUSTOM) {
      const start = this.state.range ? format(this.state.range.startDate, 'YYYY-MM-DD HH:mm:ss') : null;
      const endDate = new Date(this.state.range.endDate);
      endDate.setHours(23, 59, 59);
      const end = this.state.range ? format(endDate, 'YYYY-MM-DD HH:mm:ss') : null;
      range = {start, end};
    }
    const temp = {period: {type: this.state.type, range}};
    updateMutation(this, temp, () => {});
  };

  render() {
    return (
      <Fragment>
        <CardGrid>
          <CardGridUnit size={1 / 3}>
            <ContentHeightCard>
              <Grid>
                {quickSettings.map((quickSetting, i) => (
                  <Grid.Unit size={1 / 2} key={i}>
                    <QuickSetting
                      onClick={() => this.select(quickSetting.key)}
                      selected={quickSetting.key === this.state.type}>
                      {quickSetting.label}
                    </QuickSetting>
                  </Grid.Unit>
                ))}
              </Grid>
              {this.state.type === FILTER_CUSTOM && <Calendar value={this.state.range} onChange={this.range} />}
            </ContentHeightCard>
          </CardGridUnit>
        </CardGrid>
        <NextPageButton hide />
      </Fragment>
    );
  }
}

const PeriodSettings = props => (
  <Query query={periodSettingsQuery} variables={{input: {favoriteId: props.favoriteId}}}>
    {({loading, error, data}) => {
      if (loading) return <Loading />;
      if (error) return <Error error={error} />;
      return <PeriodSettingsContainer settings={data.settings} {...props} />;
    }}
  </Query>
);

export default withApollo(PeriodSettings);
